<template>
	<el-dialog title="资源获取记录" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false"
		:append-to-body="true" @close="closeEvent" @closed="closedEvent">
		<div>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column prop="date" label="资源名称" width="300">
					<template slot-scope="scope">
						<div style="display: table; width: 100%; position: relative;">
							<el-image style="width: 90px; height: 90px; box-shadow: 0 0 3px #ccc; float: left; margin-right: 10px;" :src="scope.row.cover" fit="contain"></el-image>
							<span class="ellipsis-twoRow" :title="scope.row.relevanceName" style="display:inline-box; display: -webkit-inline-box; float: left; width: calc( 100% - 110px ); position: absolute; top: 50%; transform: translateY(-50%);">{{scope.row.relevanceName}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="date" label="获取途径" width="180">
					<template slot-scope="scope">
           {{scope.row.acquireSource==='distribute'?scope.row.sourceName:callDictionaries(acquireSourcelist,scope.row.acquireSource)}}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="获取日期" width="180">
				</el-table-column>
			</el-table>
		</div>
		<div style=" width: 100%; overflow: hidden;">
			<div style="float: right; margin-top: 10px;">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="listquery.pageNum" :page-sizes="[10, 20, 30, 40, 50]" :page-size="listquery.pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
			
		</div>
		
	</el-dialog>
</template>
<script>
	import {
		selectMyResourceListBundle,
	} from "@/api/user/myResources.js";
  import {
    teachingAttrList, //字典值
  } from "@/api/bookstore/bookstore";
	export default {
		data() {
			return {
				dialogVisible: false,
				tableData: [],
				listquery: {
					pageNum: 1,
					pageSize: 10,
				},
				total: 0,
        acquireSourcelist: [], //获取途径字典
			}
		},
    created(){
      
    },
		methods: {
			openDialog(type, data) {
				this.dialogVisible = true
				this.getList()
        this.getresource_source(); //获取来源的字典
			},
			closeEvent() {
				this.formList = {}
			},
      getresource_source() {
        //来源
        teachingAttrList("resource_source").then((res) => {
          this.acquireSourcelist = res.data;
        });
      },
			closedEvent() {},
			getList(){
				selectMyResourceListBundle(this.listquery).then((res) => {
					this.tableData = res.rows
					this.total = res.total
				});
			},
			handleCancel() {
				this.dialogVisible = false
			},
			//每页条数
			handleSizeChange(val) {
				this.listquery.pageSize = val;
				this.getList();
			},
			//当前页面
			handleCurrentChange(val) {
				this.listquery.pageNum = val;
				this.getList();
			},
		}
	}
</script>
